import { render, staticRenderFns } from "./ChoreCell.vue?vue&type=template&id=a8ee3706&scoped=true"
import script from "./ChoreCell.vue?vue&type=script&lang=js"
export * from "./ChoreCell.vue?vue&type=script&lang=js"
import style0 from "./ChoreCell.vue?vue&type=style&index=0&id=a8ee3706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ee3706",
  null
  
)

export default component.exports